import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SETTINGS } from '../config/common.settings';

export interface ActionLog {
  _id?: string;
  action: string;
  user?: {
    _id: string;
    firstname?: string;
    lastname?: string;
    email?: string;
    name?: string;
    username?: string;
  } | { $oid: string };
  details?: string;
  createdAt?: string;
}

@Injectable({
  providedIn: 'root',
})
export class ActionLogsService {
  constructor(private http: HttpClient) {}

  // Get all logs (with optional filters)
  getAllLogs(filters: any = {}): Promise<ActionLog[]> {
    return new Promise((resolve, reject) => {
      this.http
        .get(`${SETTINGS.BASE_API}/action-log/get-all`, { params: filters })
        .subscribe({
          next: (response: any) => resolve(response?.data || []),
          error: (error: any) => reject(error.error || error),
        });
    });
  }

  // Create a new action log
  createLog(payload: ActionLog): Promise<ActionLog> {
    return new Promise((resolve, reject) => {
      this.http
        .post(`${SETTINGS.BASE_API}/action-log/create`, payload)
        .subscribe({
          next: (response: any) => resolve(response?.data),
          error: (error: any) => reject(error.error || error),
        });
    });
  }
}
